<template>
  <el-container>
    <el-main>
      <el-row>
        <el-col :span="24">
          <ReportByProductByMonthFilters @onYearSelected="OnYearSelected" />
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <ReportByProductByMonthTable :yearSelected="yearSelected" />
        </el-col>
      </el-row>
    </el-main>
  </el-container>
</template>

<script>
import ReportByProductByMonthFilters from "@/components/requests/reports/reportByproductByMonth/ReportByProductByMonthFilters";
import ReportByProductByMonthTable from "@/components/requests/reports/reportByproductByMonth/ReportByProductByMonthTable";

const actualYear = new Date().getFullYear();

export default {
  name: "RequestByProduct",
  components: {
    ReportByProductByMonthFilters,
    ReportByProductByMonthTable
  },
  data() {
    return {
      yearSelected: actualYear
    };
  },
  methods: {
    OnYearSelected(year) {
      console.log("OnYearSelected 1: ", year);
      this.yearSelected = year;
    }
  }
};
</script>

<style lang="scss" scoped></style>
